import type { ReactNode } from "react";
import { VendorWithoutAuthHeader } from "../header/VendorWithoutAuthHeader";

type Props = {
	children: ReactNode;
};

export function VendorWithoutAuthLayout({ children }: Props) {
	return (
		<>
			<VendorWithoutAuthHeader />
			<main>{children}</main>
		</>
	);
}
